
import { defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";

interface Filter {
  status: string | number;
  name: string;
  type: string | number;
  short_key: string;
  frontend_base_url: string;
  rest_api_url: string;
  rpc_namespace: string;
  overall_notes: string;
}

export default defineComponent({
  name: "filter-app-dropdown",
  components: {},
  emits: ["submit-filter", "reset-filter"],
  props: {
    selectData: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const formRef = ref<null | HTMLFormElement>(null);

    const formData = ref<Filter>({
      status: "",
      name: "",
      type: "",
      short_key: "",
      frontend_base_url: "",
      rest_api_url: "",
      rpc_namespace: "",
      overall_notes: "",
    });

    const submit = () => {
      emit("submit-filter", formData.value);
    };

    const handleReset = () => {
      formRef.value?.resetFields();
      emit("reset-filter");
    };

    return {
      t,
      formData,
      formRef,
      submit,
      handleReset,
    };
  },
});
